import { ContentPreviewer, Flex, ReadonlyField } from '@shared/components';

import { QuestionChoiceListForQuestionCreation } from '../../components';
import { useSingleQuestionDetails } from '../../providers';

export default function DetailView() {
  const { singleQuestion } = useSingleQuestionDetails();

  return (
    <Flex sx={{ flexDirection: 'column', gap: 4 }}>
      <ReadonlyField content={<ContentPreviewer content={singleQuestion.details ?? ''} />} />
      <QuestionChoiceListForQuestionCreation
        choices={singleQuestion.metadata.choices}
        value={singleQuestion.correctAnswer?.value ?? ''}
      />
    </Flex>
  );
}
